// ページの実スクロール位置を読むだけにし、Lenisの移動先や区画の高さは変更しない。
export function initStickyCopy(hold, {
  copy, buttons, mosaic, initialId, desktop, reducedMotion, scroller = hold.ownerDocument.defaultView,
}, Observer = ResizeObserver) {
  const view = hold.ownerDocument.defaultView;
  const content = hold.querySelector('.submv-content');
  let ready = false;
  let stickyLayout;
  let frame = 0;
  let autoTimer = 0;
  let selectedId = null;
  let pendingId = null;
  let shown = false;
  let destroyed = false;

  const immediate = () => reducedMotion.matches || hold.ownerDocument.hidden;
  const select = (id, highlight = true) => {
    buttons.forEach((button) => {
      const selected = button.dataset.topic === id;
      button.setAttribute('aria-pressed', String(selected));
      button.closest('article')?.classList.toggle('is-active', ready && highlight && selected);
    });
  };
  const cancelAuto = () => {
    view.clearTimeout(autoTimer);
    autoTimer = 0;
  };
  const reveal = () => {
    if (!ready || pendingId === null || destroyed) return;
    const id = pendingId;
    pendingId = null;
    content.classList.add('is-copy-revealed');
    copy.setAttribute('aria-hidden', 'false');
    if (immediate()) { mosaic.show(id); mosaic.finish(); }
    else mosaic.reveal(id);
    shown = true;
  };
  const activate = (id) => {
    if (!ready || destroyed) return;
    cancelAuto();
    if (selectedId === id) return;
    selectedId = pendingId = id;
    if (shown && !immediate()) mosaic.prepare(id);
    select(id);
    if (immediate()) reveal();
  };
  const onColorEnd = (event) => {
    if (event.target !== event.currentTarget || !['background-position-x', 'background-position-y'].includes(event.propertyName)) return;
    const button = buttons.find((item) => item.dataset.topic === pendingId);
    if (button?.closest('article') === event.currentTarget) reveal();
  };
  const finishPending = () => {
    if (!ready || !immediate()) return;
    if (autoTimer) activate(initialId);
    else reveal();
  };
  const update = () => {
    frame = 0;
    if (destroyed) return;
    const sticky = desktop.matches;
    const top = scroller === view ? 0 : scroller.getBoundingClientRect().top + scroller.clientTop;
    const nextReady = !sticky || hold.getBoundingClientRect().top <= top + 1;
    if (stickyLayout === sticky && ready === nextReady) return;
    stickyLayout = sticky;
    ready = nextReady;
    cancelAuto();
    selectedId = pendingId = null;
    shown = false;
    content.classList.remove('is-copy-revealed');
    copy.setAttribute('aria-hidden', 'true');
    mosaic.finish();
    select(null);
    if (ready) {
      if (!sticky) {
        select(initialId, false);
        content.classList.add('is-copy-revealed');
        copy.setAttribute('aria-hidden', 'false');
        mosaic.show(initialId);
        mosaic.finish();
        shown = true;
      } else if (immediate()) activate(initialId);
      else autoTimer = view.setTimeout(() => activate(initialId), 500);
    }
  };
  const requestUpdate = () => {
    if (!frame && !destroyed) frame = view.requestAnimationFrame(update);
  };
  const observer = new Observer(requestUpdate);
  observer.observe(hold);
  if (scroller !== view) observer.observe(scroller);
  scroller.addEventListener('scroll', requestUpdate, { passive: true });
  view.addEventListener('resize', requestUpdate);
  desktop.addEventListener('change', requestUpdate);
  reducedMotion.addEventListener('change', finishPending);
  hold.ownerDocument.addEventListener('visibilitychange', finishPending);
  const articles = [...new Set(buttons.map((button) => button.closest('article')).filter(Boolean))];
  articles.forEach((article) => article.addEventListener('transitionend', onColorEnd));
  update();

  return {
    show(id) {
      view.cancelAnimationFrame(frame);
      update();
      activate(id);
    },
    destroy() {
      destroyed = true;
      view.cancelAnimationFrame(frame);
      cancelAuto();
      observer.disconnect();
      scroller.removeEventListener('scroll', requestUpdate);
      view.removeEventListener('resize', requestUpdate);
      desktop.removeEventListener('change', requestUpdate);
      reducedMotion.removeEventListener('change', finishPending);
      hold.ownerDocument.removeEventListener('visibilitychange', finishPending);
      articles.forEach((article) => article.removeEventListener('transitionend', onColorEnd));
      content.classList.remove('is-copy-revealed');
      copy.removeAttribute('aria-hidden');
      ready = false;
      select(null);
    },
  };
}
